import type { ComponentConfig } from "@puckeditor/core";
import { Video } from "./video";
import { VideoFields } from "./video.fields";
import type { VideoProps } from "./video";
import { getWindowJobsiteConfig } from "../../types/runtime-config";

const VideoConfig: ComponentConfig<VideoProps> = {
  defaultProps: {
    caption: "",
    heading: "",
    subheading: "",
    videoUrl: "",
  },
  fields: {
    heading: { ...VideoFields.heading, contentEditable: true },
    subheading: { ...VideoFields.subheading, contentEditable: true },
    videoUrl: VideoFields.videoUrl,
    caption: { ...VideoFields.caption, contentEditable: true },
  },
  label: "Video",
  render: ({ id, puck: _puck, editMode, ...props }) => {
    const windowConfig = getWindowJobsiteConfig();
    return <Video id={id} {...props} isEditing={Boolean(windowConfig.isEditing ?? editMode)} />;
  },
};

export { VideoConfig };
